import { createBrowserRouter } from "react-router-dom";
import { decorateWithSentry } from "@tiny/sentry";

const createBrowserRouterWithSentry = decorateWithSentry(createBrowserRouter);

export { createBrowserRouterWithSentry };
